import styled from 'styled-components';

export const ProgressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
`;

export const Value = styled.div`
  font-size: 13px;
  line-height: 12px;
`;

export const ProgressBar = styled.div<{ leftOffset: string }>`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #fff;
  overflow: hidden;
  height: 8px;
  width: 65px;
  position: relative;

  &::after {
    display: block;
    height: 8px;
    width: 65px;
    position: absolute;
    border-radius: 8px;
    top: 0;
    left: ${(props) => `calc(${props.leftOffset}% - 100%)`};
    content: '';
    background-color: #ec691a;
  }
`;
